module.exports = __webpack_public_path__ + "img/Game_target_Z-16.980535e8.png";